<template>
  <div class="admininEnter">
    <div class="admin_img">
      <div>
        <img src="@/assets/images/outbound.png" alt="" @click="linkAssetsOut" />
        <p>出库</p>
      </div>
      <div>
        <img src="@/assets/images/entrance.png" alt="" @click="linkAssetsIn" />
        <p>入库</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "adminIndex",
  methods: {
    linkAssetsOut() {
      this.$router.push("assetsOut");
    },
    linkAssetsIn() {
      this.$router.push("assetsEnter");
    },
  },
};
</script>

<style scoped lang="less">
.admininEnter {
  height: 100vh;
  background-color: #ffffff;
  .admin_img {
    padding: 66px 148px 0;
    display: flex;
    div {
      text-align: center;
      &:first-child {
        margin-right: 166px;
      }
      img {
        width: 144px;
        float: left;
        margin-bottom: 9px;
      }
      p {
        font-size: 32px;
        color: #333333;
      }
    }
  }
}
</style>
